import React, { useState, useEffect, useContext, useCallback } from "react";
import { MyContext } from "../..";
import { updateUserProfile } from "../../services";
import Alert from "react-popup-alert";
// import { Link } from "react-router-dom";
import "./profile.css"

export default function StudentProfile(props) {
  document.title = props.title;
  const queryParameters = new URLSearchParams(window.location.search);
  const username = queryParameters.get("username") || props.username;
  const subscriberCode = queryParameters.get("subcode") || props.subCode
  const { backendUrl } = useContext(MyContext);
  const [role] = useState(queryParameters.get("role") || props.role)

  const [formData, setFormData] = useState({
    // Initialize the form fields with default values or leave them empty
    firstName: "",
    lastName: "",
    username: username,
    email: "",
    grade: "",
    graduationYear: ""
  });
  const [alert, setAlert] = React.useState({
    type: "error",
    text: "This is a alert message",
    show: false,
  });

  const fetchStudentData = useCallback(async () => {
    try {
      const response = await fetch(
        `${backendUrl}/student/profile?username=${username}`
      );
      if (response.ok) {
        const data = await response.json();
        // Update the form fields with the retrieved data
        setFormData({
          username: username,
          subscriberCode: subscriberCode,
          firstName: data.data.first_name || "",
          lastName: data.data.last_name || "",
          email: data.data.email || "",
          grade: data.data.grade || "",
          graduationYear: data.data.graduation_year || "",
          parentName1: data.data.parent_name_1 || "",
          parentName2: data.data.parent_name_2 || "",
          address: data.data.address || "",
          phoneNumber: data.data.phone_number || "",
          parentEmail1: data.data.parent_email_1 || "",
          parentEmail2: data.data.parent_email_2 || "",
          notes: data.data.notes || "",
          skypeId: data.data.skype_id || ""
          // Add other form fields here
        });
      } else {
        console.error("Failed to fetch student data");
      }
    } catch (error) {
      console.error("Error fetching student data:", error);
    }
  }, [backendUrl, username, subscriberCode]);

  useEffect(() => {
    // Fetch student data when the component mounts
    fetchStudentData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // You can handle form submission logic here
    const response = await updateUserProfile(backendUrl, formData);
    console.log("Profile updated successfully");
    if (response.code === 200) {
      setAlert({
        type: "success",
        text: "Student Profile updated successfully",
        show: true,
      });
    } else {
      setAlert({
        type: "",
        text: response.message,
        show: true,
      });
    }
  };
  function onCloseAlert() {
    setAlert({
      type: "",
      text: "",
      show: false,
    });
  }
  return (
    <div>
      <Alert
        header={"Message"}
        btnText={"Close"}
        text={alert.text}
        type={alert.type}
        show={alert.show}
        onClosePress={onCloseAlert}
        pressCloseOnOutsideClick={true}
        showBorderBottom={true}
        alertStyles={{}}
        headerStyles={{}}
        textStyles={{}}
        buttonStyles={{}}
      />
      <div className="container container-group-body form-body-container">
        <form onSubmit={handleSubmit}>
          <div className="form-strip-box">
            <div className="box-info-lable"><span>Username: </span>{formData.username}</div>
            <div className="strip-btn-group">
              <button type="submit" className="strip-form-btn">UPDATE</button>
            </div>
          </div>
          <div className="form-box-container">
            <div className="input-box">
              <label htmlFor="firstname">First Name</label>
              <input type="text" id="firstname" name="firstName" value={formData.firstName} onChange={handleChange} pattern="[A-Za-z]+"
                title="Please enter a valid first name (only letters)."
                required />
            </div>
            <div className="input-box">
              <label htmlFor="lastname">Last Name</label>
              <input type="text" id="lastname" name="lastName" value={formData.lastName} onChange={handleChange} pattern="[A-Za-z]+"
                title="Please enter a valid last name (only letters)."
                required />
            </div>
            <div className="input-box">
              <label htmlFor="email">Email</label>
              <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required />
            </div>
            <div className="input-box">
              <label htmlFor="grade">Grade</label>
              <input type="number" id="grade" name="grade" value={formData.grade} onChange={handleChange} max={15} required />
            </div>
            <div className="input-box">
              <label htmlFor="graduationYear">Graduation Year</label>
              <input type="number" id="graduationYear" name="graduationYear" value={formData.graduationYear} onChange={handleChange} max={2099} min={1800} />
            </div>
            <div className="input-box">
              <label htmlFor="address">Address</label>
              <input type="text" id="address" name="address" value={formData.address} onChange={handleChange} />
            </div>
            <div className="input-box phone-input">
              <label htmlFor="phoneNumber">Phone Number</label>
              <input type="number" id="phoneNumber" name="phoneNumber" value={formData.phoneNumber} onChange={handleChange} max={9999999999} min={999999999} required />
            </div>
            <div className="input-box">
              <label htmlFor="skypeId">Skype ID</label>
              <input type="text" id="skypeId" name="skypeId" value={formData.skypeId} onChange={handleChange} />
            </div>
            <div className="input-box">
              <label htmlFor="parentName1">Parent Name 1</label>
              <input type="text" id="parentName1" name="parentName1" value={formData.parentName1} onChange={handleChange} />
            </div>
            <div className="input-box">
              <label htmlFor="parentName2">Parent Name 2</label>
              <input type="text" id="parentName2" name="parentName2" value={formData.parentName2} onChange={handleChange} />
            </div>
            <div className="input-box">
              <label htmlFor="parentEmail1">Parent Email 1</label>
              <input type="text" id="parentEmail1" name="parentEmail1" value={formData.parentEmail1} onChange={handleChange} />
            </div>
            <div className="input-box">
              <label htmlFor="parentEmail2">parent Email 2</label>
              <input type="text" id="parentEmail2" name="parentEmail2" value={formData.parentEmail2} onChange={handleChange} />
            </div>
            {role==="a" && 
              <div className="input-box" style={{width: "95%"}}>
                <label htmlFor="notes">Notes</label>
                <input type="text" id="notes" name="notes" style={{width: "100%"}} value={formData.notes} onChange={handleChange} />
              </div>
            }
          </div>
        </form>
      </div>
    </div>
  );
}
